// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout } from "@/layouts"
import { baojiadan_icon,tongjibaobiao_icon,yibiaopan_icon,gongshiku_icon,gongshishenbao_icon,xiangmushezhi_icon,shujudaoru_icon,yonghuguanli_icon,xitongshezhi_icon,msg_icon,usercenter_icon,download_icon } from "@/core/icons"

const RouteView = {
  name: "RouteView",
  render: (h) => h("router-view"),
}

export const asyncRouterMap = [
  // (飞书入口)
  {
    path: "/hourSystem",
    name: "hourSystem",
    component: () => import("@/views/entry/index.vue"),
    meta: {
      title: "工时申报",
      keepAlive: true,
      permission: ["hourSystem"],
      permissions: ["工时申报"],
    },
  },
  // 管理后台入口
  {
    path: "/",
    name: "index",
    component: BasicLayout,
    meta: { title: "访客管理" },
    redirect: "/system",
    children: [
      // 统计报表
      {
        path: "/statisticalReport",
        component: RouteView,
        redirect: "/statisticalReport/laborCosts",
        meta: {
          title: "统计报表",
          icon: "profile",
          permission: ["statisticalReport"],
          permissions: ["统计报表"],
        },
        children: [
          {
            path: "/statisticalReport/laborCosts",
            name: "LaborCosts",
            component: () => import("@/views/statisticalReport/laborCosts"),
            meta: {
              title: "测试报表",
              keepAlive: true,
              permission: ["statisticalReport"],
              permissions: ["测试报表"],
            },
          },
        ],
      },
      // 访客
      {
        path: "/visit",
        component: RouteView,
        redirect: "/visit/reservation",
        meta: {
          title: "访客管理",
          icon: "profile",
          permission: ["visit"],
          permissions: ["访客管理"],
        },
        children: [
          {
            path: "/visit/reservation",
            name: "Visit",
            component: () => import("@/views/visit/reservation"),
            meta: {
              title: "访客预约",
              keepAlive: true,
              permission: ["visit"],
              permissions: ["访客预约"],
            },
          },
          {
            path: "/visit/approveConfig",
            name: "ApproveConfig",
            component: () => import("@/views/visit/approveConfig"),
            meta: {
              title: "审批保安配置",
              keepAlive: true,
              permission: ["userManage"],
              permissions: ["审批保安配置"],
            },
          },
        ],
      },
      // 系统设置
      {
        path: "/system",
        component: RouteView,
        redirect: "/system/role",
        meta: {
          title: "系统设置",
          icon: "profile",
          permission: ["system"],
          permissions: ["系统设置"],
        },
        children: [
          {
            path: "/system/role",
            name: "Role",
            component: () => import("@/views/userManage/role"),
            meta: {
              title: "角色权限",
              keepAlive: true,
              permission: ["system"],
              permissions: ["系统设置"],
            },
          },
          {
            path: "/userManage/departmentMember",
            name: "DepartmentMember",
            component: () => import("@/views/userManage/departmentMember"),
            meta: {
              title: "组织用户",
              keepAlive: true,
              permission: ["userManage"],
              permissions: ["组织用户"],
            },
          },
          
        ],
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: "/404",
    component: () =>
      import(/* webpackChunkName: "fail" */ "@/views/exception/404"),
  },
]
